import {getCookie, setCookie} from "../../sources/js/functions/helpers";

(function () {
    const languageButtons = document.querySelectorAll("[data-language-button]");

    if (languageButtons) {
        languageButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const code = btn.dataset.languageButton

                setCookie('current_language', code, false)
                setCookie('current_language_lock', 1, false)

                const modals = document.querySelectorAll('[data-modal]');
                if (modals) {
                    modals.forEach(modal => modal.classList.remove('modal_active'));
                }
            });
        })
    }

    if (!getCookie('current_language_lock') && ICL_LANGUAGE_CODE) {
        setCookie('current_language', ICL_LANGUAGE_CODE, false)
    }
}());

(function () {
    const scrollBtn = document.querySelector('[data-scroll-takeloan]');

    if (scrollBtn) {
        const btnBehavior = () => {
            window.scrollY > 420 ? scrollBtn.classList.add('show') : scrollBtn.classList.remove('show')
        }

        btnBehavior()

        document.addEventListener('scroll', () => btnBehavior());
    }
}());
